import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 12px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n\n  &:checked ~ ", " {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  &:disabled ~ ", " {\n    background-color: transparent;\n    border-color: transparent;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border: 2px solid ", ";\n  border-radius: 2px;\n  display: inline-flex;\n  flex: 0 0 16px;\n  height: 16px;\n  justify-content: center;\n  position: relative;\n  width: 16px;\n\n  svg {\n    position: absolute;\n    width: 16px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  color: ", ";\n  cursor: ", ";\n  display: flex;\n  font-size: 14px;\n  font-weight: 500;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 2px;\n  position: absolute;\n  width: 12px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { cobaltBlue, lightSteel, mineShaft, steel, white } from '../../styles/colors';
export var Dash = styled.span(_templateObject(), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? steel : white;
});
export var CheckboxLabel = styled.label(_templateObject2(), mineShaft, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 'default' : 'pointer';
});
export var CheckboxSquare = styled.span(_templateObject3(), white, lightSteel);
export var HiddenCheck = styled.input.attrs({
  type: 'checkbox'
})(_templateObject4(), CheckboxSquare, cobaltBlue, cobaltBlue, CheckboxSquare);
export var LabelContainer = styled.div(_templateObject5());